module.exports = __webpack_public_path__ + "static/img/0401_01.5626222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0401_01.png
// module id = NP1f
// module chunks = 1